export const UPDATE_VERSION_CONFIG = {
  HAS_NEW_VERSION: {
    title: 'به‌روزرسانی جدید موجود است!',
    description: 'برای بهره‌مندی از ویژگی‌های جدید، اپلیکیشن را به آخرین نسخه ارتقا دهید!',
    cta: 'به‌روزرسانی',
  },
  LATEST_VERSION: {
    title: 'اپلیکیشن به‌روز است!',
    description: 'شما در حال استفاده از آخرین نسخه‌ی دیجی‌پی هستید!',
    cta: 'به‌روزرسانی مجدد',
  },
  ERROR: {
    title: 'بررسی به‌روزرسانی با خطا مواجه شده است',
    description: 'برای بهره‌مندی از ویژگی‌های جدید، اپلیکیشن را به آخرین نسخه ارتقا دهید!',
    cta: 'به‌روزرسانی مجدد',
  },
  CHECKING: {
    title: 'در حال بررسی به‌روزرسانی!',
    description: 'از شکیبایی شما سپاسگزاریم...',
    cta: '',
  },
};
